import type { IPerson } from 'src/interfaces';

export const getPersonName = ({ firstName, lastName }: Pick<IPerson, 'firstName' | 'lastName'>) => {
  return [firstName, lastName].filter(Boolean).join(' ');
};
